import React from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { TabDashboard } from "../../componentes/molecules/TabDashboard";
import WebsocketContext from "../../context/hooks/WebSocket";

export const Dashboard = () => {
  return (
    <>
      < Navbar />

      < Sidebar />

      < TabDashboard />
    </>
  )
}


